import { FC, useState } from 'react';
import { Link } from "react-router-dom";

import * as Meta from 'meta';
import { ROUTE } from "route";
import { useAuth } from "hooks";
import { gaEvent } from "utils";
import { Modal, Notice } from "components";

export const Header: FC = () => {
  const auth = useAuth();
  const [isShowNotice, setIsShowNotice] = useState(false);

  const handleShowNotice = (isShow: boolean) => {
    setIsShowNotice(isShow);
  };

  return (
    <>
      <div className="header">
        {Meta.loadCSS('header')}
        <div className="logo">
          <Link to={ROUTE.HOME} onClick={gaEvent.bind(null, 'menu', 'logo')}>
            <img src="/resources/html/images/logo.svg" alt="台灣啤酒" />
          </Link>
        </div>

        <nav className="nav">
          <ul>
            <Link className="index_top" to={ROUTE.HOME} onClick={gaEvent.bind(null, 'menu', '回到首頁')}><li>回到首頁</li></Link>
            <Link to="/#songprize" onClick={gaEvent.bind(null, 'menu', '爽爽好禮')}><li id="songprize_bt">爽爽好禮</li></Link>
            <li onClick={() => {
              handleShowNotice(true);
              gaEvent('menu', '活動辦法');
            }}>活動辦法</li>
            <Link to={ROUTE.WINNER} onClick={gaEvent.bind(null, 'menu', '得獎公告')}><li>得獎公告</li></Link>
            {auth.isAuth && <Link to={ROUTE.RECORD} onClick={gaEvent.bind(null, 'menu', '觀看抽獎紀錄')}><li>觀看抽獎紀錄</li></Link>}
          </ul>
        </nav>

        <div className="burger">
          <div className="line" />
          <div className="line" />
          <div className="line" />
        </div>
      </div>
      {isShowNotice &&
        <Modal onClose={handleShowNotice}><Notice /></Modal>
      }
    </>
  );
};
